<div class="card border-0 shadow-sm">
  <div class="card-header bg-primary">
    <div class="row align-items-center">
      <div class="col-lg mb-3 mb-lg-0">
        <h5 class="text-white mb-0">
          {{ title() }}
        </h5>
      </div>

      <div class="col-lg-auto ms-auto">
        <button
          type="button"
          class="btn btn-secondary me-3"
          (click)="collapsed = !collapsed"
        >
          <i
            class="fa-solid fa-md"
            [ngClass]="collapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
          ></i>
        </button>

        <button
          type="button"
          class="btn btn-light"
          ngbPopover="Delete"
          triggers="mouseenter:mouseleave"
          (click)="deleteMatch()"
        >
          <i class="fa-solid fa-trash fa-md"></i>
        </button>
      </div>
    </div>
  </div>

  <div
    class="card-body p-0"
    #collapse="ngbCollapse"
    [(ngbCollapse)]="collapsed"
  >
    <div class="container text-bg-secondary px-0 py-4">
      <div class="row gx-0 gy-4">
        <div class="col-lg-6">
          <app-media-edit
            [src]="data.media[0] || ''"
            (onSelectFile)="handleSelectMedia($event, 0)"
          ></app-media-edit>
        </div>

        <div class="col-lg-6">
          <app-media-edit
            [src]="data.media[1] || ''"
            (onSelectFile)="handleSelectMedia($event, 1)"
          ></app-media-edit>
        </div>

        <div class="col-12">
          <div class="row">
            <div class="col-12 px-0 pt-2">
              <div
                class="row w-100 text-center align-items-center gy-3 gy-lg-4 my-auto"
              >
                <!-- ! TODO: Fetch from service -->
                <div class="col-lg-5">
                  <label for="home" class="form-label mb-1"> HOME </label>

                  <ng-select
                    id="home"
                    appearance="outline"
                    [(ngModel)]="data.home"
                    [items]="filteredTeams"
                    bindLabel="name"
                    bindValue="id"
                    (ngModelChange)="handleTeamChange()"
                    placeholder="Select a team"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>

                <div class="col-lg-auto mx-auto">
                  <p class="mb-0">VS</p>
                </div>

                <div class="col-lg-5">
                  <label for="away" class="form-label mb-1"> AWAY </label>

                  <ng-select
                    id="away"
                    appearance="outline"
                    [(ngModel)]="data.away"
                    [items]="filteredTeams"
                    bindLabel="name"
                    bindValue="id"
                    (ngModelChange)="handleTeamChange(true)"
                    placeholder="Select a team"
                    [clearable]="false"
                  >
                  </ng-select>
                </div>
                <!-- ! TODO: Fetch from service -->

                <div class="col-md col-lg-3 col-input">
                  <label for="date" class="form-label"> Date </label>

                  <app-custom-date-picker
                    [date]="data.date"
                    (onDateChange)="data.date = $event"
                  ></app-custom-date-picker>
                </div>

                <div class="col-md col-lg col-input">
                  <label for="broadcast" class="form-label">
                    Broadcast(s)
                  </label>

                  <ng-select
                    id="broadcast"
                    appearance="outline"
                    [items]="channels"
                    bindLabel="name"
                    class="mt-auto custom-select"
                    [(ngModel)]="broadcasts"
                    (ngModelChange)="handleBroadcastChange()"
                    placeholder="Broadcast"
                    [clearable]="false"
                    [multiple]="true"
                    [maxSelectedItems]="4"
                  >
                    <ng-template
                      ng-multi-label-tmp
                      let-clear="clear"
                      class="custom-select-template"
                    >
                      <!--  -->
                      @for (item of broadcasts | slice: 0 : 2; track item) {
                      <div class="ng-value">
                        <span
                          class="ng-value-icon left"
                          (click)="clear(item)"
                          aria-hidden="true"
                          >x</span
                        >
                        <span class="ng-value-label">{{ item.name }}</span>
                      </div>
                      } @if (broadcasts.length > 2) {
                      <div class="ng-value">
                        <span class="ng-value-label"
                          >{{ broadcasts.length - 2 }} más...</span
                        >
                      </div>
                      }
                      <!--  -->
                    </ng-template>
                  </ng-select>
                </div>

                <div class="col-md col-lg col-input">
                  <label for="viwership" class="form-label">
                    Viewership
                    {{ viewership() ? '(' + viewership() + ')' : '' }}
                  </label>

                  <app-custom-input-number
                    [data]="data.viewership"
                    placeholder="Viwership"
                    (onDataChange)="
                      data.viewership = $event; calculateTotalImpressions()
                    "
                  ></app-custom-input-number>
                </div>

                <div class="col-12">
                  <p class="mb-1">Total Impressions</p>

                  <h4 class="text-light mb-0">
                    {{ data.impressions | number : '1.0-0' }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container bg-secondary-subtle py-4 px-0">
      <div class="row gy-3 gy-lg-0 text-center">
        <div class="col-md-3">
          <p class="mb-1">Units Contracted</p>

          <app-custom-input-number
            [data]="data.unitsContracted"
            placeholder="Units Contracted"
            (onDataChange)="data.unitsContracted = $event; calculateUnits()"
          ></app-custom-input-number>
        </div>

        <div class="col-md-3">
          <p class="mb-1">Units Delivered</p>

          <p class="fw-bold mb-0">
            {{ data.unitsDelivered | number : '1.3-3' }}
          </p>
        </div>

        <div class="col-md-3">
          <p class="mb-1">Time Contracted</p>

          <p class="fw-bold mb-0">
            {{
              ('' + data.timeContracted.minutes).padStart(2, '0') +
                ':' +
                ('' + data.timeContracted.seconds).padStart(2, '0')
            }}
          </p>
        </div>

        <div class="col-md-3">
          <p class="mb-1">Time Delivered</p>

          <p class="fw-bold mb-0">
            {{
              ('' + data.timeDelivered.minutes).padStart(2, '0') +
                ':' +
                ('' + data.timeDelivered.seconds).padStart(2, '0')
            }}
          </p>
        </div>
      </div>
    </div>

    <div class="container bg-white rounded-bottom py-4">
      <div class="row gy-4 gx-0">
        <div class="col-xl-6">
          <div class="d-block">
            <p class="fw-bold text-center mb-3">First Half of Insertions</p>

            <app-time-controller
              [data]="data.firstTimes"
              [total]="data.totalFirst"
              (onTimeChange)="calculateTimeContracted()"
            ></app-time-controller>
          </div>
        </div>

        <div class="col-xl-6">
          <div class="d-block">
            <p class="fw-bold text-center mb-3">Second Half of Insertions</p>

            <app-time-controller
              [data]="data.secondTimes"
              [total]="data.totalSecond"
              (onTimeChange)="calculateTimeContracted()"
            ></app-time-controller>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
